<!-- https://github.com/themesberg/flowbite-svelte/blob/v0.48.6/src/lib/forms/Label.svelte -->
<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import type { HTMLLabelAttributes } from "svelte/elements";

	interface $$Props extends HTMLLabelAttributes {
		color?: "gray" | "green" | "red" | "disabled";
		defaultClass?: string;
		show?: boolean;
		disabled?: boolean;
	}

	export let color: NonNullable<$$Props["color"]> = "gray";
	export let defaultClass: $$Props["defaultClass"] = "text-sm rtl:text-right font-medium block";
	export let show: $$Props["show"] = true;
	export let disabled: $$Props["disabled"] = false;

	let node: HTMLLabelElement;

	const colorClasses = {
		gray: "text-gray-900 dark:text-gray-300",
		green: "text-green-700 dark:text-green-500",
		red: "text-red-700 dark:text-red-500",
		disabled: "text-gray-400 dark:text-gray-500 grayscale contrast-50",
	};

	$: disabled = typeof disabled === "boolean" ? disabled : (node?.control as HTMLInputElement)?.disabled;

	$: labelClass = twMerge(defaultClass, colorClasses[disabled ? "disabled" : color], $$props.class);
</script>

{#if show}
	<label bind:this={node} {...$$restProps} class={labelClass}><slot /></label>
{:else}
	<slot />
{/if}
